/**
* Theme: Adminto - Responsive Bootstrap 5 Admin Dashboard
* Author: Coderthemes
* Module/App: Main Js
*/


import $ from 'jquery';
window.$ = $;
window.jQuery = $;

import 'simplebar';

import moment from 'moment';
window.moment = moment;